import { Injectable } from "@angular/core";
import { EditorController } from "../controller/editor.controller";
import { ContextMenuItem } from '@farris/ui-context-menu';
import { Tab } from "../interface/tab";
import { TabsHandler } from "../interface/handler/tabs-handler";
import { LocaleService } from '@farris/ui-locale';
import { CODE_VIEW_DESIGNER_LOCALE } from '../utils/locale'
@Injectable()
export class TabContextMenuService {

  localeData = CODE_VIEW_DESIGNER_LOCALE["zh-CHS"].codeViewDesigner
  constructor(private controller: EditorController,private localeService: LocaleService) { 
    if(this.localeService) {
      this.localeData = this.localeService.getValue('codeViewDesigner')
    }
  }

  public getContextMenuItems(): ContextMenuItem[] {
    return [{
      id: 'close',
      title: this.localeData.close || '关闭',
      handle: (data: { tab: Tab }) => {
        const tab = data.tab;
        const path = tab && tab.id;
        this.controller.closeFile(path);
      }
    }, {
      id: 'close-other',
      title: this.localeData.closeOthers || '关闭其他',
      handle: (data: { tab: Tab }) => {
        const tab = data.tab;
        const path = tab && tab.id;
        this.controller.closeOtherFile(path);
      },
      disable: () => {  // 大于一个标签页时启用
        const contextSrv = this.controller.getContextService();
        if (contextSrv && contextSrv.fileItems && contextSrv.fileItems.length > 1) {
          return false;
        }
        return true;
      }
    }, {
      id: 'close-to-the-right',
      title: this.localeData.closeRight || '关闭右侧',
      handle: (data: { tab: Tab }) => {
        const tab = data.tab;
        const path = tab && tab.id;
        this.controller.closeToTheRight(path);
      },
      disable: (data: { tab: Tab, tabsRef: TabsHandler }) => {  // 右侧存在标签页时启用
        const curTab = data.tab;
        const tabs = data.tabsRef.tabs;
        const idx = tabs.findIndex(t => t.id === curTab.id);
        return idx < 0 || idx === tabs.length - 1;
      }
    }, {
      id: 'close-all-saved-file',
      title: this.localeData.closeSaved || '关闭已保存',
      handle: () => {
        this.controller.closeAllSavedFile();
      }
    }, {
      id: 'close-all',
      title: this.localeData.closeAll || '全部关闭',
      handle: () => {
        this.controller.closeAllFile();
      }
    }];
  }

}
